module.exports = __webpack_public_path__ + "static/media/EngineerStudents_MuseumofArt-8.16228604.jpg";